import {useDataProvider, useNotify, useQuery, useRefresh} from "react-admin";
import React from "react";
import {Form, Switch} from "antd";
import {createSubmitHandler} from "@src/components/Settings/utils";
import {ExtendedDataProvider} from "@src/types";


const SubmissionBuilderSettingsForm = () => {
    const notify = useNotify ()
    const [form] = Form.useForm ();
    const refresh = useRefresh();
    const dataProvider: ExtendedDataProvider = useDataProvider ()
    const settingsName = "SubmissionBuilder"

    const {loaded, error, data: currentSettings} = useQuery ({
        type: 'getOne',
        resource: 'general_settings',
        payload: {id: settingsName}
    });

    return (
        <>
            {
                (loaded || error) &&
                <Form
                    form={form}
                    labelAlign='left'
                    labelCol={{ span: 10 }}
                    wrapperCol={{ span: 14 }}
                    onFinish={createSubmitHandler(settingsName, currentSettings, dataProvider, notify, refresh)}
                >
                    <Form.Item
                        label={"Show Submission Builder"}
                        initialValue={currentSettings?.['config']?.show_submission_builder || false}
                        name="show_submission_builder"
                        rules={[{required: true}]}
                    >
                        <Switch defaultChecked={currentSettings?.['config']?.show_submission_builder == true}/>
                    </Form.Item>

                    <Form.Item
                        label={"Enable Submit Functionality"}
                        initialValue={currentSettings?.['config']?.enable_submit_functionality || false}
                        name="enable_submit_functionality"
                        rules={[{required: true}]}
                    >
                        <Switch defaultChecked={currentSettings?.['config']?.enable_submit_functionality == true}/>
                    </Form.Item>

                    <Form.Item
                        label={"Default Allow Submit"}
                        initialValue={currentSettings?.['config']?.default_allow_submit_submission_builder || false}
                        name="default_allow_submit_submission_builder"
                        rules={[{required: true}]}
                    >
                        <Switch defaultChecked={currentSettings?.['config']?.default_allow_submit_submission_builder == true}/>
                    </Form.Item>

                </Form>
            }
        </>
    )
}

export default SubmissionBuilderSettingsForm;
